import { render, staticRenderFns } from "./inforce_TP.vue?vue&type=template&id=8edafdb6&scoped=true&"
import script from "./inforce_TP.vue?vue&type=script&lang=js&"
export * from "./inforce_TP.vue?vue&type=script&lang=js&"
import style0 from "./inforce_TP.vue?vue&type=style&index=0&id=8edafdb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edafdb6",
  null
  
)

export default component.exports